import React from 'react';
import { store } from '../store.js';
import { connect } from 'react-redux';
import Select from 'react-select';
import InfiniteCalendar from 'react-infinite-calendar';

import _ from 'lodash';

import {
    CurrCode,
    NewAddressForm,
    TimePicker,
    FoodType
} from '../reactComp';

import Moment from '../clientTime';


import {
    handleCoupon,
    setCustomerDetail,
    placeOrder,
    preProcessOrder
} from '../actions';

const sat_api = require('../../js/api');

@connect((store) => {
	return {
		currentOrderSession:store.currentOrderSession,
	}
})
export default class CheckOutPage extends React.Component{
	render(){
		var cSession = this.props.currentOrderSession;
		return(
			<div className="checkout-section-container">
				<div className="checkout-user-input">
					<OrderDetailPreview />
					<UserMobileNoPrev userObj={cSession.user}
						no={cSession.user.phone}
						name={cSession.user.name}
						email={cSession.user.email}
					    savingCustomerName={cSession.savingCustomerName}
						savingCustomerNameStatus={cSession.savingCustomerNameStatus}/>
					{(cSession.delivery_mode == 'pickup' ? <PickupAddress /> : <DeliveryAddress />)}
					<RedeemCoupon />
					<DeliveryTime/>
					<PaymentModes/>
					{
						cSession.delivery_info.payment_mode === 'aggregator' &&
						<PaymentAggregator />
					}
					<OrderChannel />
					<OrderNote />
					<PlaceOrderButton />
				</div>
				<div className="order-preview-container float-left">
					<BillSummary />
				</div>
			</div>
		)
	}
}



@connect((store) => {
	return {
		currentOrderSession:store.currentOrderSession
	}
})
class RedeemCoupon extends React.Component{
	constructor(props){
		super(props)
		this.state = {
			coupon:{
				code:(this.props.currentOrderSession.coupon && this.props.currentOrderSession.coupon.data && this.props.currentOrderSession.coupon.data.code ? this.props.currentOrderSession.coupon.data.code : "")
			},
			expand:true
		}
	}
	componentWillMount(){

	}
	validateCoupon(){
		var cSession = this.props.currentOrderSession;
		var coupon_payload = {
			"code": this.state.coupon.code,
			"order": sat_api.getOrderPayload({...cSession})
		};

		store.dispatch(handleCoupon(coupon_payload))
	}
	handleCoupon(e){
		if(e.nativeEvent.keyCode === 13) {
			this.validateCoupon()
		}
	}
	submitCoupon(){
		this.validateCoupon()
	}
	updateCouponCode(e){
		this.setState({
			coupon:{
				code:e.target.value.toUpperCase()
			}
		})
	}
	errorMessage() {
        let session = this.props.currentOrderSession;
        if(session.coupon.error && session.coupon.data.data)
            return this.props.currentOrderSession.coupon.data.data.message;
        else
            return "";
	}
	render(){
		var couponInStore = this.props.currentOrderSession.coupon
		return(
			<div className={(this.state.expand ? "expand" : "")+" checkout-steps"}>
				<div className="checkout-steps-header">
					Apply Coupon
				</div>
				<div className="redeem-coupon checkout-steps-content">
					<div className={(couponInStore.error ? "error" : "")+ " coupon-code-container"}>
						<input
							type="text"
							placeholder="Coupon Code"
							onChange={(e)=>this.updateCouponCode(e)}
							onKeyPress={(e)=>this.handleCoupon(e)}
							value={this.state.coupon.code}>
						</input>
						<div className={(couponInStore.loading? "blink-highlight" : "")+(couponInStore.data && !couponInStore.error? " applied" : "")+" redeem-button"} onClick={()=>this.submitCoupon()}>{(!couponInStore.error && couponInStore.data ? "Applied" : "Apply") }</div>
					</div>
					<div className={(couponInStore.error ? "error" : "success")+" m-t-10 coupon-message messaging"}>
						{(couponInStore.data ? couponInStore.data.message : "") }
					</div>
					<p className="error-color">{this.errorMessage()}</p>
				</div>
			</div>
		)
	}
}



@connect((store) => {
	return {
		currentOrderSession:store.currentOrderSession
	}
})
class OrderDetailPreview extends React.Component {
	constructor(props){
		super(props)
		this.state = {
			expand:false
		}
	}
	expand() {
		this.setState({
			expand : !this.state.expand
		})
	}

	render(){
		var cart = this.props.currentOrderSession.cart;
		var pricing = sat_api.getCartToPricing(cart);
		if(cart.items.length > 0){
			var itemNodes = cart.items.map((o,i) => {
				return(
					<SummaryItemNode item={o} key={i}/>
				)
			})
		}else{
			var itemNodes = (()=>{
				return(
					<div className="text-center bold padding-10 large-text">
						No item in your cart
					</div>
				)
			})()
		}
		var arrowClass = (this.state.expand ? "rotate-180" :"")
		return(
			<div className={(this.state.expand ? "expand" : "")+" checkout-steps"}>
				<div className="checkout-steps-header cursor-pointer" onClick={(e)=>this.expand(e)}>
					<div className="float-left">
						Order Summary
					</div>
					<div className="float-right">
						<div className={"default-transition "+arrowClass}>&#9662;</div>
					</div>
					<div className="clearfix"></div>
				</div>
				<div className="order-summary-container checkout-steps-content">
					{itemNodes}
				</div>
			</div>
		)
	}
}


class UserMobileNoPrev extends React.Component{
	constructor(props){
		super(props);
		var name = this.props.name.trim(" ");
		var email = this.props.email;

		var expand=false;

		if(!/[a-zA-Z ]{3,}/.test(name)){
			expand = true;
			name = '';
		}
		if(!sat_api.UTILS.emailOnly(email)){
			expand = true;
			email = "";
		}
		this.state = {
			expand,
			name
		}
	}

	header() {
        if (this.state.expand) {
            return <div className="float-left"> &nbsp; {this.props.no} </div>
        }
        else {
		    return <div className="float-left m-l-10">{this.props.no}  &nbsp; | &nbsp; {this.state.name} </div>
		}
	}

	saveCustomerDetail() {
	    let user = {
		    customer_phone: this.props.no.replace("+", ""),
	    }

		var {name, email} = this.state;

		var validName = (name && name != "" && name.trim() != "");
		var validEmail = (email == "" || typeof(email) == "undefined" || sat_api.UTILS.emailOnly(email));

		if(validName && validEmail){
			var name = name.split(" ");
			if(name.length > 1 ){
	            user.first_name = name[0];
	            user.last_name = name.slice(1)[0];
	        }else {
	            user.first_name = name[0];
	            user.last_name = "";
	        }
			user.email = email;

			store.dispatch(setCustomerDetail({
				user_data: user,
				prefetched_user_obj:this.props.userObj
			}))

		}else {
			var errStr = "Enter valid detail";
			if(validName){
				errStr = "Enter valid email";
			}
			if(validEmail){
				errStr = "Enter valid name";
			}
			store.dispatch({
				type:"ERROR_SAVING_CUSTOMER_NAME",
				payload:{
					error_message:errStr
				}
			})
		}
	}
	resetErrorStatus(){
		store.dispatch({
			type:"RESET_SAVING_CUSTOMER_NAME",
			payload:{
				error_message:""
			}
		})
	}
	body() {
		let errorStyle = {
			"position": "absolute",
    		"bottom": "-5px",
    		"left": "20px",
    		"color": "red"
		}
	    let buttonClasses = "up-button default large secondary grey-border"
		let btnStyle = {
			"padding": "10px",
    		"width": "100px",
    		"textAlign": "center"
		}
	    if(this.props.savingCustomerName) {
	        buttonClasses += ' blink-highlight'
	    }
    	return (<div className={"checkout-steps-content default-transition user-info-content" + (this.state.expand ? " expand": "")}>
				<div>
					<div className="padding-10 relative-pos">
						<div style={errorStyle}>{this.props.savingCustomerNameStatus}</div>
				        <input
							onFocus={(e)=>{this.resetErrorStatus(e)}}
							type="text"
							name="checkout_customer_name" placeholder="Customer Name"
							value={this.state.name}
							onChange={(e) => {this.setState({name: e.target.value})}}
						/>

					<input
							onFocus={(e)=>{this.resetErrorStatus(e)}}
							type="text"
							name="checkout_customer_email" placeholder="Customer Email"
							value={this.state.email}
							onChange={(e) => {this.setState({email: e.target.value})}}
						/>
				        <a style={btnStyle} className={buttonClasses}
							onClick={(e)=>{this.saveCustomerDetail(e)}}
							>Save</a>
					</div>
				</div>
			</div>)
	}
	render(){
		return(
			<div className={(this.state.expand ? "expand" : "")+" checkout-steps"}>
				<div className="checkout-steps-header">
					<div className="float-left">Mobile No</div>
					{this.header()}
					<div className="clearfix"></div>
				</div>
                {this.body()}
			</div>
		)
	}
}


@connect((store) => {
	return {
		currentOrderSession:store.currentOrderSession,
	}
})
class PickupAddress extends React.Component{
	constructor(props){
		super(props)
	}
	render(){
		var cSession = this.props.currentOrderSession;
		return(
			<div className="expand checkout-steps">
				<div className="checkout-steps-header">
					Pickup Address
				</div>
				<div className="checkout-steps-content">
					<div>
						<div className="padding-10">
							<div className="bold large-text">
								{cSession.store.name}
							</div>
							<div className="addressDetail m-t-10">
								{cSession.store.address}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}


@connect((store) => {
	return {
		currentOrderSession:store.currentOrderSession,
	}
})
class DeliveryAddress extends React.Component{
	constructor(props){
		super(props)

		var cSession = this.props.currentOrderSession;

		this.state = {
			expand:true,
			switched:(cSession.user.saved_addresses.length == 0)
		}
	}

	switchClick(e){
		this.setState({switched:!this.state.switched})
	}

	expand(){
		this.setState({
			expand: !this.state.expand
		})
	}

	selectAddress(e,d){
		var delivery_info = {...this.props.currentOrderSession.delivery_info};
		delivery_info.address_id = d.id;

		store.dispatch({
			type:'SET_DELIVERY_INFO',
			payload:delivery_info
		})
	}
	componentDidMount(){
		let scrollHeight = this.addressContainer.scrollHeight;
		let clientHeight = this.addressContainer.clientHeight;

		let isOverflowing = scrollHeight>clientHeight;

		if(isOverflowing){
			this.setState({"shadow":true})
		}else{
			this.setState({"shadow":false})
		}
	}

	render(){
		var cSession = this.props.currentOrderSession;
		var selectedAddress = cSession.delivery_info.address_id;
		var addresses = cSession.user.saved_addresses;
		var addressNode = addresses.map((o,i) => {
			return(
				<div className={(o.id == selectedAddress ? "selected" :"")+" saved-address-row"} key={i} onClick={(e,d)=>this.selectAddress(e,o)}>
					<div>
						<div className="large-text relative-pos">
							<span className="custom-checkbox-address-tag"></span>
							<span style={{"paddingLeft":"22px"}}>{o.tag}</span>
						</div>
						<div className="addressDetail m-t-10" style={{"paddingLeft":"22px"}}>
							<div>{o.sub_locality}</div>
							<div>{o.address_1}  {o.landmark || o.address_2}</div>
							<div>{o.city} - {o.pin}</div>
						</div>
					</div>
				</div>
			)
		})
		if(addresses.length == 0){
			(()=>{
				return(
					<div className="text-center padding-10">No saved address!</div>
				)
			})()
		}

		return(
			<div className={(this.state.expand ? "expand" : "")+" checkout-steps"}>
				<div className="checkout-steps-header">
					Delivery Address
				</div>
				<div className="checkout-steps-content">
					<div>
						<div className={(this.state.switched ? "switched" : "")+" switch"} style={{"transform":"translate(-19px)"}}>
							<div className={(!this.state.switched ? "switched-el" : "")}>Saved Addresses</div>
							<div>
								<span className="switch-rail" onClick={(e)=>this.switchClick(e)}></span>
							</div>
							<div className={(this.state.switched ? "switched-el" : "")}>New Address</div>
						</div>
						<div ref={(el) => {this.addressContainer = el}} className={(this.state.shadow && !this.state.switched  ? "address-container-shadow" : "") + " address-overflow-control"} style={{"maxHeight":"325px", "overflow":"auto"}}>
							{(this.state.switched ? <NewAddressForm/> : addressNode)}
						</div>
					</div>
				</div>
			</div>
		)
	}
}


@connect((store) => {
	return {
		currentOrderSession:store.currentOrderSession,
		bizInfo:store.bizInfo
	}
})
class DeliveryTime extends React.Component{
	constructor(props){
		super(props)
		this.state = {
			switched:false,
			slotsAvaiable:false,
			slots:[],

		}
	}

	getSlots(d){
		let todayInMilli = function(time_string) {
			var today = new Date();
			var selectedTimeToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), time_string[0], time_string[1], time_string[2]);
			return selectedTimeToday.getTime();
		}

		let tConvert = function(time) {
			// Check correct time format and split into components
			time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

			if (time.length > 1) {
				// If time format correct
				time = time.slice(1); // Remove full string match value
				time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
				time[0] = +time[0] % 12 || 12; // Adjust hours
			}
			return time.join(''); // return adjusted time or original string
		}

		//check if it's there in store level. Otherwise take from biz

		const available_slots_for_week = this.state.slotsAvaiable;


		const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
		let day = weekday[d];
		let available_slots = _.filter(available_slots_for_week, { 'day': day });

		let todayDayName = new Date().getDay();

		let slots = [];
		for (var x in available_slots) {
			var display_date_e = available_slots[x].end_time.split(":");
			display_date_e.splice(2, 1);
			display_date_e = display_date_e.join(":");

			var display_date_s = available_slots[x].start_time.split(":");
			display_date_s.splice(2, 1);
			display_date_s = display_date_s.join(":");

			var startTime = todayInMilli(available_slots[x].start_time.split(':'));
			var endTime = todayInMilli(available_slots[x].end_time.split(':'));

			let offset = (45*60*1000);
			if(this.props.currentOrderSession.delivery_mode == 'delivery'){
				offset = this.props.currentOrderSession.store.delivery_min_offset_time;
			}else {
				offset = this.props.currentOrderSession.store.pickup_min_offset_time;
			}

			let now = new Date().getTime()+offset // add offset also;


			if (d == todayDayName) {
				if (endTime > now ) {
					var slotObj = {
						start_time:{
							value:available_slots[x].start_time,
							string:tConvert(display_date_s)
						},
						end_time:{
							value:available_slots[x].end_time,
							string:tConvert(display_date_e)
						}
					}
					slots.push(slotObj)
				}
			}else{
				var slotObj = {
					start_time:{
						value:available_slots[x].start_time,
						string:tConvert(display_date_s)
					},
					end_time:{
						value:available_slots[x].end_time,
						string:tConvert(display_date_e)
					}
				}
				slots.push(slotObj)
			}
		}
		return slots;
	}

	switchClick(e){
		this.setState({switched:!this.state.switched})
		store.dispatch({
			type:'SET_DELIVERY_TIME',
			payload:{now:this.state.switched}
		})
	}
	handleDelTime(e){
		console.log(e)
		store.dispatch({
			type:'SET_DELIVERY_TIME',
			payload:{now:false,delivery_time:e}
		})
	}


	setSlotInState(delivery_date){
		let slotsDay = new Date(delivery_date).getDay();
		let availableSlots = this.getSlots(slotsDay);
		if(availableSlots && availableSlots.length > 0) {
			this.setState({
				slots: availableSlots
			})
		}else {
			this.setState({
				slots: []
			})
		}

		let _payload = 'no_slot_available';
		if(availableSlots && availableSlots[0]) {
			_payload = {
				time_slot_start:availableSlots[0].start_time.value,
				time_slot_end:availableSlots[0].end_time.value
			}
		}
		store.dispatch({
			type:'SET_DELIVERY_SLOT',
			payload:_payload
		})
	}
	componentWillReceiveProps(newProps) {
		if(this.props.currentOrderSession.delivery_date != newProps.currentOrderSession.delivery_date){
			if(this.state.slotsAvaiable){
				this.setSlotInState(newProps.currentOrderSession.delivery_date)
			}
		}
	}

	componentDidMount() {
		let slotsAvaiable = (()=>{
			let storeSlots = this.props.currentOrderSession.store.time_slots;
			if(storeSlots && storeSlots.length > 0) {
				return storeSlots
			}else {
				if(this.props.bizInfo.data.time_slots && this.props.bizInfo.data.time_slots.length > 0){
					return this.props.bizInfo.data.time_slots;
				}
			}
			return null
		})()

		//if we have slots
		if(slotsAvaiable){
			this.setState({
				slotsAvaiable:slotsAvaiable
			},()=>{
				let delivery_date = this.props.currentOrderSession.delivery_date || new Date().getTime();
				console.log(delivery_date)
				this.setSlotInState(delivery_date);
			})
		}else {
			this.setState({
				slotsAvaiable:null
			})
		}

		store.dispatch({
			type:'SET_DELIVERY_TIME',
			payload:{now:true,delivery_time:null}
		})

	}

	openDatePicker(){
		store.dispatch({
			type:'SHOW_DATE_PICKER',
			payload:{
				selectedDate: this.props.currentOrderSession.delivery_date
			}
		})
	}

	handleSlotChange(e){
		let slot = e.target.value;
		let _payload = {
			time_slot_start:slot.split("-")[0],
			time_slot_end:slot.split("-")[1]
		}
		store.dispatch({
			type:'SET_DELIVERY_SLOT',
			payload:_payload
		})
	}

	render(){
		var cSession = this.props.currentOrderSession;
		var selectedDate = cSession.delivery_date // in milli

		return(
			<div className="expand checkout-steps">
				<div className="checkout-steps-header">
					{(cSession.delivery_mode == 'pickup' ? 'Pickup' : 'Delivery')} Time
				</div>
				<div className="checkout-steps-content delivery-time-choice-container">
					<div className={(this.state.switched ? "switched" : "")+" delivery-time-choice"}>
						<div className={(this.state.switched ? "switched" : "")+" switch"}>
							<div className={(!this.state.switched ? "switched-el" : "")}>Now</div>
							<div>
								<span className="switch-rail" onClick={(e)=>this.switchClick(e)}></span>
							</div>
							<div className={(this.state.switched ? "switched-el" : "")}>Later</div>
						</div>
					</div>
					<div className={(!this.state.switched ? "hide-imp" : "")+" text-center time-picker"}>
						<div onClick={(e)=>this.openDatePicker(e)} style={{"color":"#2196F3"}} className="cursor-pointer m-b-10 default-inline-container date-picker-trigger">
							<div>
								<img height="20px" src="data:image/svg+xml;utf8;base64,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" />
							</div>
							<div>
								{Moment(selectedDate).format('D MMM, Y')}
							</div>
						 </div>
						{
							this.state.slotsAvaiable ?
							<SlotsMarkup selectedDate={selectedDate} handleSlots={this.handleSlotChange} data={this.state.slots}/>
							:
							<TimePicker  mounted={this.state.switched} onChange={(e)=>this.handleDelTime(e)}/>
						}
					</div>
				</div>
				<DatePickerController/>
			</div>
		)
	}
}


@connect((store) => {
	return {
		currentOrderSession:store.currentOrderSession,
	}
})
class PaymentModes extends React.Component{
	constructor(props){
		super(props)
		this.state = {
			expand:true
		}
	}

	setPaymentMode(e,d){
		var cSession = {...this.props.currentOrderSession};
		cSession.delivery_info.payment_mode = d;

		store.dispatch({
			type:'SET_DELIVERY_INFO',
			payload:cSession.delivery_info
		})

	}
	render(){
		var cSession = this.props.currentOrderSession;
		var payment_mode = cSession.delivery_info.payment_mode;

		return(
			<div className={(this.state.expand ? "expand" : "")+" checkout-steps"}>
				<div className="checkout-steps-header">
					Payment Mode
				</div>
				<div className="payment-modes checkout-steps-content">
					<div className="payment-modes-block m-t-10 m-b-10" onClick={(e)=>this.setPaymentMode(e, "cash")}>
						<input type="radio" className="m-r-10" value="cash" onChange={function() {}} checked={(payment_mode == 'cash')} />
						Cash on delivery
					</div>
					<div className="payment-modes-block m-t-10 m-b-10" onClick={(e)=>this.setPaymentMode(e, "aggregator")}>
					    <input type="radio" className="m-r-10" value="cash" onChange={function() {}}
					           checked={(payment_mode == 'aggregator')} />
						Through Aggregator
					</div>
				</div>
			</div>
		)
	}
}


@connect((store) => ({
	currentOrderSession: store.currentOrderSession,
}))
class PaymentAggregator extends React.Component{
	constructor(props) {
		super(props);
		this.state = {
			expand: true,
		};
	}

	setPaymentAggregator = (e, d) => {
		const cSession = {...this.props.currentOrderSession};
		cSession.delivery_info.payment_aggregator = d;
		store.dispatch({
			type: 'SET_DELIVERY_INFO',
			payload: cSession.delivery_info,
		});
	}

	render() {
		const cSession = this.props.currentOrderSession;
		const { payment_aggregator } = cSession.delivery_info;
		return (
			<div className={(this.state.expand ? "expand" : "")+" checkout-steps"}>
				<div className="checkout-steps-header">
					Payment Aggregator
				</div>
				<div className="payment-modes checkout-steps-content">
					<div className="payment-modes-block m-t-10 m-b-10" onClick={(e)=>this.setPaymentAggregator(e, "paytm")}>
						<input
							type="radio"
							className="m-r-10"
							// value="cash"
							onChange={function() {}}
							checked={(payment_aggregator === 'paytm')}
						/>
						PayTM
					</div>
					<div className="payment-modes-block m-t-10 m-b-10" onClick={(e)=>this.setPaymentAggregator(e, "googlepay")}>
						<input
							type="radio"
							className="m-r-10"
							// value="cash"
							onChange={function() {}}
							checked={(payment_aggregator === 'googlepay')}
						/>
						Google Pay
					</div>
					<div className="payment-modes-block m-t-10 m-b-10" onClick={(e)=>this.setPaymentAggregator(e, "phonepe")}>
						<input
							type="radio"
							className="m-r-10"
							// value="cash"
							onChange={function() {}}
							checked={(payment_aggregator === 'phonepe')}
						/>
						PhonePe
					</div>
					<div className="payment-modes-block m-t-10 m-b-10" onClick={(e)=>this.setPaymentAggregator(e, "card")}>
						<input
							type="radio"
							className="m-r-10"
							// value="cash"
							onChange={function() {}}
							checked={(payment_aggregator === 'card')}
						/>
						Card
					</div>
					<div className="payment-modes-block m-t-10 m-b-10" onClick={(e)=>this.setPaymentAggregator(e, "airpay")}>
						<input
							type="radio"
							className="m-r-10"
							// value="cash"
							onChange={function() {}}
							checked={(payment_aggregator === 'airpay')}
						/>
						Airpay
					</div>
					<div className="payment-modes-block m-t-10 m-b-10" onClick={(e)=>this.setPaymentAggregator(e, "other")}>
						<input
							type="radio"
							className="m-r-10"
							// value="cash"
							onChange={function() {}}
							checked={(payment_aggregator === 'other')}
						/>
						Other
					</div>
				</div>
			</div>
		);
	}
}

@connect((store) => {
	return {
		currentOrderSession:store.currentOrderSession,
		loginReducer:store.loginReducer
	}
})
class OrderChannel extends React.Component{
	constructor(props){
		super(props)
		this.state = {
			expand:true,
			ext_platforms:[]
		}
	}
	getFormattedChannel(i) {
		if(!i) {
			return (
				{
					label:'Satellite',
					value:'satellite'
				}
			)
		}
		return (
			{
				label:i.charAt(0).toUpperCase() + i.substr(1),
				value:i
			}
		)

	}
	componentDidMount(){
		store.dispatch({
			type:'SET_ORDER_CHANNEL',
			payload: this.props.currentOrderSession.order_channel || "satellite"
		})

		var ext_platforms = this.props.loginReducer.data.biz.external_platforms;
		var ext_platforms_formatted = _.map(ext_platforms, (i,d)=>{
			if(i == 'urbanpiper'){
				return (
					{
						label:'Satellite',
						value:'satellite'
					}
				)
			}else {
				return (
					{
						label:i.charAt(0).toUpperCase() + i.substr(1),
						value:i
					}
				)
			}
		})
		this.setState({
			ext_platforms:ext_platforms_formatted
		})
	}


	setChannel(selectedChannel) {

	    store.dispatch({
			type:'SET_ORDER_CHANNEL',
			payload: selectedChannel.value
		})
	}

	setExterChannelId(e){
		store.dispatch({
			type:'SET_EXTERNAL_CHANNEL_ID',
			payload: e.target.value
		})
	}
	render(){
		var cSession = this.props.currentOrderSession;



		var external_channel_input_style = {
			"padding": "10px",
			"width": "100%",
			"boxSizing": "border-box",
			"borderRadius": "4px",
			"border": "1px solid #ddd",
			"marginTop":"10px"
		}

		return(
			<div className={(this.state.expand ? "expand" : "")+" checkout-steps"}>
				<div className="checkout-steps-header">
				    Ordering Channel (optional)
				</div>
				<div className="checkout-steps-content order-channel">
				        <div>
							<Select
								optionClassName="needsclick"
								value={this.getFormattedChannel(this.props.currentOrderSession.order_channel)}
								options={this.state.ext_platforms}
								placeholder="Select One"
	  				            onChange={this.setChannel.bind(this)}
								autoBlur={true}
							/>
						</div>
						<div className={(this.props.currentOrderSession.order_channel == 'satellite' ? "hide" : "")}>
							<input
								onChange={(e)=>{this.setExterChannelId(e)}}
								style={external_channel_input_style}
								type="text"
								placeholder="Enter external order id *"
								value={this.props.currentOrderSession.external_channel_id}
							/>
						</div>
				</div>
			</div>
		)
	}
}




@connect((store) => {
	return {
		currentOrderSession:store.currentOrderSession
	}
})
class OrderNote extends React.Component{
	constructor(props){
		super(props)
		this.state = {
			expand:true
		}
	}
	orderNode(e){
		var order_note = e.target.value;

		var delivery_info = {...this.props.currentOrderSession.delivery_info};
		delivery_info.order_note = order_note;

		store.dispatch({
			type:'SET_DELIVERY_INFO',
			payload:delivery_info
		})

	}
	render(){
		return(
			<div className={(this.state.expand ? "expand" : "")+" checkout-steps"}>
				<div className="checkout-steps-header">
					Order Notes
				</div>
				<div className="order-notes checkout-steps-content" onChange={(e)=>this.orderNode(e)}>
					<textarea>

					</textarea>
				</div>
			</div>
		)
	}
}

@connect((store) => {
	return {
		currentOrderSession:store.currentOrderSession,
		loginReducer:store.loginReducer,
		placingOrder:store.placingOrder,
		preprocessedData:store.preprocessedData
	}
})
class PlaceOrderButton extends React.Component{
	constructor(props){
		super(props)
	}

	componentWillUnmount() {
	    store.dispatch({
            type: "RESET_ORDER_ERRORS",
        });
	}
	validAddress() {
	    let cos = this.props.currentOrderSession;
	    if(cos.delivery_mode === "delivery") {
			if(cos.delivery_info && cos.delivery_info.address_id){
				return true
			}
            let {address_1, landmark, lat, lng, pincode} = cos.delivery_info && cos.delivery_info.guest_address ? cos.delivery_info.guest_address : {};
            if(!(address_1 )) {
                store.dispatch({
                    type: "ORDER_VALIDATION_ERROR",
                    message: "Please enter the customer's address"
                });
                return false;
             }

			 if(!lat || !lng){
				 store.dispatch({
                     type: "ORDER_VALIDATION_ERROR",
                     message: "Please choose valid locality form the drop down."
                 });
                 return false;
			 }
	    }
	    return true;
	}

	channelValidation(){
		var channel = this.props.currentOrderSession.order_channel
		if(channel == 'satellite'){
			return true
		}

		if(channel!='satellite'){
			var external_channel_id = this.props.currentOrderSession.external_channel_id;

			if(!external_channel_id){
				store.dispatch({
					type: "ORDER_VALIDATION_ERROR",
					message: "Please enter valid external channel ID"
				 });
				 return false;
			}else {
				return true
			}
		}
	}

	placeOrder(){
	    if(!this.validAddress()) return;
		if(!this.channelValidation()) return;

		var cSession = this.props.currentOrderSession;

		if(cSession.slot && cSession.slot == 'no_slot_available'){
			store.dispatch({
				type: "ORDER_VALIDATION_ERROR",
				message: "No slots available"
			});
			return false;
		}
		var placeOrderRe = this.props.placingOrder;

		if(!placeOrderRe.loading){
			if(this.props.preprocessedData.data){
				var _data = {...cSession}
				_data.preprocessedData = {...this.props.preprocessedData.data.order}
				var orderPayload = sat_api.getOrderPayload(_data);
				orderPayload.biz_id = this.props.loginReducer.data.biz.biz_id;
				store.dispatch(placeOrder(orderPayload))

				sat_api.MP_TRACK("order_placed", orderPayload)
			}else {
				alert('Something went wrong, try agian.');
			}
		}
	}
	changeOrder(){
		store.dispatch({
			type:"CHANGE_ORDER",
			payload:null
		})
	}
	errorDiv(message) {
		return(
            <div className="padding-10 m-t-10 error messaging text-center">
                {message}
            </div>
        )
	}
	render(){
		var placeOrderRe = this.props.placingOrder;
		var error_message = (()=>{
		    if (placeOrderRe.errorMessage) {
                return this.errorDiv(placeOrderRe.errorMessage);
		    }
			else if(placeOrderRe.error && placeOrderRe.data){
                return this.errorDiv(placeOrderRe.data.message);
			}
			else{
				return null
			}
		})()
		return(
			<div>
				{error_message}
				<div className="text-center padding-10">
					<a  onClick={(e)=>this.placeOrder(e)} className={(placeOrderRe.loading ? "progress-status":"")+" full-width up-button default large primary place-order-button"}>Place Order</a>
				</div>
			</div>
		)
	}
}

class SummaryItemNode extends React.Component {
	constructor(props){
		super(props)
	}
	render(){
		var item = this.props.item;
		var item_total_price = item.item_price + _.reduce(item.options, function (s, entry) {
			return s + parseFloat(entry.price);
		}, 0)
		var optionNodes = item.options.map((o,i) => {
			return(
				<div key={i} className="static-optios-node">
					{o.title}
				</div>
			)
		})

		return(
			<div className="static-item-nodes-row padding-10">
				<div className="float-left" style={{"width":"50%"}}>
					<div className="static-item-title">
						<div className="med-text m-b-5"><FoodType type={item.food_type}/> {item.item_title}</div>
						<div className="" style={{"paddingLeft":"15px"}}>{optionNodes}</div>
					</div>
				</div>
				<div className="float-right" style={{"width":"50%", "lineHeight":"20px"}}>
					<span style={{"fontSize": "14px","color":"#ccc"}}>x{item.quantity}</span>   <span className="float-right"><CurrCode />{item_total_price*item.quantity}</span>
				</div>
				<div className="clearfix"></div>
			</div>
		)
	}
}


@connect((store) => {
	return {
		currentOrderSession:store.currentOrderSession,
		preprocessedData:store.preprocessedData
	}
})
class BillSummary extends React.Component {
	constructor(props){
		super(props)
		this.state = {
			fixed:false
		}
		this.handleScroll = this.handleScroll.bind(this)
	}

	preProcessOrder(){
		var cSession = this.props.currentOrderSession;
		var orderPayload = sat_api.getOrderPayload({...cSession})
		var data = {...orderPayload,biz_id:store.getState().loginReducer.data.biz.biz_id, phone:cSession.user.phone}

		store.dispatch(preProcessOrder(data))
	}
	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll);
		this.preProcessOrder()
	}

	componentWillUnmount() {
	    window.removeEventListener('scroll',this.handleScroll);
	}

	handleScroll(){
		let scrollTop = window.scrollY;
		if(scrollTop>110){
			this.setState({fixed:true})
		}else{
			this.setState({fixed:false})
		}

	}
	changeOrder(){
		store.dispatch({
			type:"COUPON_RESET",
			payload:null
		})
		store.dispatch({
			type:"CHANGE_ORDER",
			payload:null
		})
	}
	summaryRow(row) {
        return (<div key={row.title}>
            <div className="float-left">
                {row.title}
            </div>
            <div className="float-right">
                <CurrCode/> {row.value}
            </div>
        </div>);
	}
	render(){

		if(this.props.preprocessedData.error){
			return(
				<div className="order-preview">
					<div className="text-center UP-ERROR-TEXT padding-10">
						<div className="bold">Order preprocessing failed</div>
						<div>{this.props.preprocessedData.data}</div>
						<div className="m-t-5"><a onClick={(e)=>this.preProcessOrder(e)} className="bold cursor-pointer">Try Again!</a></div>
					</div>
				</div>
			)
		}

		var cSession = this.props.currentOrderSession;
		if(this.props.preprocessedData.data && this.props.preprocessedData.data.order){
			var processdData = this.props.preprocessedData.data.order;
			var coupon = cSession.coupon.data;

			var deliveryCharge = (()=>{
				var delivery_mode = cSession.delivery_mode;
				if(delivery_mode == 'delivery'){
					return(
						<div>
							<div className="float-left">
								Delivery charge
							</div>
							<div className="float-right">
								<CurrCode/> {(coupon && coupon.success ? coupon.meta.delivery_charge : processdData.delivery_charge)}
							</div>
						</div>
					)
				}else{
					return null
				}
			})()

			var delivery_mode = cSession.delivery_mode;
			var _total = parseFloat((coupon && coupon.success ? coupon.meta.order_total : (processdData.order_total)))

			var _sub_total = (coupon && coupon.success ? coupon.meta.order_subtotal : processdData.order_subtotal )
			var _tax = (coupon &&  coupon.success ? coupon.meta.item_taxes : processdData.item_taxes )
			var _packaging_charge = (coupon &&  coupon.success ? coupon.meta.packaging_charge : processdData.packaging_charge )

        let chargeObjects, taxObjects;
        if (processdData.charges && (processdData.item_level_total_taxes || processdData.order_level_total_taxes)) {
            taxObjects = [{title: 'Item Taxes', value: processdData.item_level_total_taxes || "0"}];
            taxObjects = taxObjects.concat(processdData.taxes);
            chargeObjects = [{title: 'Item Charges', value: processdData.item_level_total_charges || "0"}];
			chargeObjects = chargeObjects.concat(processdData.charges);
        }
        else {
            taxObjects = [{title: 'Taxes', 'value': processdData.item_taxes || "0"}];
		    chargeObjects = [{title: 'Delivery', value: processdData.delivery_charge || "0"},
		                     {title: 'Packaging', value: processdData.packaging_charge || "0"}]
		}
		var taxes = taxObjects.map(this.summaryRow);
		var charges = chargeObjects.map(this.summaryRow);
		}



		var discount = (()=>{
			if(coupon && coupon.success){
				return(
					<div className="discount">
						<div className="float-left">
							Discount
						</div>
						<div className="float-right">
							<CurrCode/> {coupon.value}
						</div>
					</div>
				)
			}else{
				return null
			}
		})()


		return(
			<div className={(this.state.fixed ? "fixed" : "")+" order-preview"+ (this.props.preprocessedData.loading ? " disabled": "")}>
				<div className="order-preview-header">
					<div className="float-left">
						Bill Summary
					</div>
					<div className="float-right">
						{cSession.cart.meta.item_count} item(s)
					</div>
				</div>
				<div className="order-preview-body">
					<div>
						<div className="float-left">
							Sub Total
						</div>
						<div className="float-right">
							<CurrCode/> {_sub_total}
						</div>
					</div>

                    {taxes}
                    {charges}

					{discount}
					<div className="payable-amount large-text">
						<div className="float-left">
							Total
						</div>
						<div className="float-right">
							<CurrCode/> {_total}
						</div>
					</div>
				</div>
				<div className="m-t-10">
					<a  onClick={(e)=>this.changeOrder(e)}className="up-button full-width default large secondary change-order-button">Change Order</a>
				</div>
			</div>
		)
	}
}


class SlotsMarkup extends React.Component{
	constructor(props){
		super(props)
	}
	componentWillReceiveProps(newProps){
		if(newProps.selectedDate != this.props.selectedDate){
			this.sl.selectedIndex = 0;
		}
	}
	render(){
		let props = this.props;
		if (props.data.length > 0){
			return(
				<div>
					<select onChange={(e)=>{props.handleSlots(e)}} ref={sl=>this.sl = sl}>
						{
							props.data.map((i, d)=>{
								return (
									<option key={d} value={i.start_time.value+"-"+i.end_time.value}>
										{i.start_time.string} - {i.end_time.string}
									</option>
								)
							})
						}
					</select>
				</div>
			)
		}else {
			return(
				<div>
					<select  ref={sl=>this.sl = sl}>
						<option value={null}>No slots available</option>
					</select>
				</div>
			)
		}
	}
}

@connect ((store)=>{
	return {
		deliveryDatePicker:store.deliveryDatePicker
	}
})
class DatePickerController extends React.Component {
	constructor(props) {
		super(props)
	}
	changeDate(e){
		var selectedDate = new Date(e).getTime();
		store.dispatch({
			type:"SET_DELIVERY_DATE",
			payload:selectedDate
		})
	}
	closeDatePicker(){
		console.log('Close datepicker')
		store.dispatch({
			type:"HIDE_DATE_PICKER",
			payload:null
		})
	}
	render(){
		return(

			<div className={(this.props.deliveryDatePicker.show ? "active" : "")+ " date-picker-container"} onClick={(e)=>this.closeDatePicker(e)}>
				<div className="infinite-calendar-holder" onClick={(e)=>e.stopPropagation(e)}>
					<div className="datepicker-close" onClick={(e)=>this.closeDatePicker(e)}>
						<img height="20px" width="20px" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUyIDUyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MiA1MjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+PGc+PHBhdGggZD0iTTI2LDBDMTEuNjY0LDAsMCwxMS42NjMsMCwyNnMxMS42NjQsMjYsMjYsMjZzMjYtMTEuNjYzLDI2LTI2UzQwLjMzNiwwLDI2LDB6IE0yNiw1MEMxMi43NjcsNTAsMiwzOS4yMzMsMiwyNiAgIFMxMi43NjcsMiwyNiwyczI0LDEwLjc2NywyNCwyNFMzOS4yMzMsNTAsMjYsNTB6IiBmaWxsPSIjRkZGRkZGIi8+PHBhdGggZD0iTTM1LjcwNywxNi4yOTNjLTAuMzkxLTAuMzkxLTEuMDIzLTAuMzkxLTEuNDE0LDBMMjYsMjQuNTg2bC04LjI5My04LjI5M2MtMC4zOTEtMC4zOTEtMS4wMjMtMC4zOTEtMS40MTQsMCAgIHMtMC4zOTEsMS4wMjMsMCwxLjQxNEwyNC41ODYsMjZsLTguMjkzLDguMjkzYy0wLjM5MSwwLjM5MS0wLjM5MSwxLjAyMywwLDEuNDE0QzE2LjQ4OCwzNS45MDIsMTYuNzQ0LDM2LDE3LDM2ICAgczAuNTEyLTAuMDk4LDAuNzA3LTAuMjkzTDI2LDI3LjQxNGw4LjI5Myw4LjI5M0MzNC40ODgsMzUuOTAyLDM0Ljc0NCwzNiwzNSwzNnMwLjUxMi0wLjA5OCwwLjcwNy0wLjI5MyAgIGMwLjM5MS0wLjM5MSwwLjM5MS0xLjAyMywwLTEuNDE0TDI3LjQxNCwyNmw4LjI5My04LjI5M0MzNi4wOTgsMTcuMzE2LDM2LjA5OCwxNi42ODQsMzUuNzA3LDE2LjI5M3oiIGZpbGw9IiNGRkZGRkYiLz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+" />
					</div>
					<InfiniteCalendar
						onSelect={(e)=>this.changeDate(e)}
						theme={{
							headerColor: '#1c2837',
							selectionColor: '#88c057',
							weekdayColor: '#34495e',
						}}
						width={400}
						height={400}
						selected={new Date(this.props.deliveryDatePicker.selectedDate)}
						min={new Date()}
						minDate={new Date()}
					/>
				</div>
			</div>
		)
	}
}
